export default __webpack_public_path__ + "static/media/icons8-redis.7827419c.svg";